import { ReactNode } from 'react'
import { Button } from '@/ui/components'
import { cn } from '@/shared/utils'

interface EmptyStateProps {
  icon: ReactNode
  title: string
  description?: string
  action?: {
    label: string
    onClick: () => void
  }
  className?: string
}

export function EmptyState({ 
  icon, 
  title, 
  description, 
  action, 
  className 
}: EmptyStateProps) {
  return (
    <div className={cn('text-center py-12', className)}>
      <div className="mx-auto mb-4">
        {icon}
      </div>
      <h3 className="text-heading-lg text-foreground mb-2">{title}</h3>
      {description && (
        <p className="text-body-md text-earth-600 mb-6 max-w-md mx-auto">
          {description}
        </p>
      )}
      {action && (
        <Button onClick={action.onClick} className="btn-primary">
          {action.label}
        </Button>
      )}
    </div>
  )
}
